import { registerAll, resetRegistry } from "../registry";
import type { Binding } from "../types";
import { documentedBindings } from "./documented";
import { editorBindings } from "./editor";
import { globalBindings } from "./global";

/**
 * Installs every binding at import time.
 *
 * Menus read shortcut labels during render, so installation cannot wait for an
 * effect — importing this module (via `@/lib/shortcuts`) is what guarantees the
 * registry is populated before anything asks it a question.
 *
 * The reset makes re-evaluation idempotent, which matters under fast refresh:
 * without it a hot reload would re-register every id and throw a duplicate-id
 * error that has nothing to do with the edit that triggered it.
 */
const ALL_BINDINGS: Binding[] = [
  ...globalBindings,
  ...editorBindings,
  ...documentedBindings,
];

resetRegistry();
registerAll(ALL_BINDINGS);
